(() => {
  const componentName = 'rubik-combined-listings';
  const productStyleId = 'dream-on-rubik-product-styles';
  const cardStyleId = 'dream-on-rubik-card-styles';

  const productStyles = `
    :host {
      --dream-rubik-pink: #ef6c98;
      --dream-rubik-pink-dark: #d84f80;
      --dream-rubik-border: rgba(239, 108, 152, 0.30);
      --dream-rubik-soft: rgba(239, 108, 152, 0.08);
      display: block;
      width: 100%;
      margin: 0.6rem 0 1.2rem;
    }

    .rcl__group {
      box-sizing: border-box;
      width: 100%;
      padding: 1rem 1.1rem 1.2rem;
      border: 0.1rem solid var(--dream-rubik-border);
      border-radius: 1.6rem;
      background: linear-gradient(135deg, rgba(255, 255, 255, 0.96), var(--dream-rubik-soft));
      box-shadow: 0 0.5rem 1.8rem rgba(216, 79, 128, 0.08);
    }

    .rcl__group-label {
      display: flex !important;
      align-items: center;
      gap: 0.75rem !important;
      width: 100%;
      margin: 0 0 0.9rem !important;
      color: #121212 !important;
      font-size: 1.5rem !important;
      font-weight: 750 !important;
      line-height: 1.2;
    }

    .rcl__group-label-separator {
      display: none;
    }

    .rcl__group-label-option-name::before {
      content: 'Elige el ';
    }

    .rcl__group-label-selected-value {
      display: inline-flex;
      align-items: center;
      min-height: 2.5rem;
      padding: 0.25rem 0.9rem;
      border: 0.1rem solid var(--dream-rubik-border);
      border-radius: 999px;
      background: var(--dream-rubik-soft);
      color: var(--dream-rubik-pink-dark) !important;
      font-size: 1.2rem !important;
      font-weight: 700 !important;
      line-height: 1;
    }

    .rcl__grid {
      display: flex !important;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start !important;
      gap: 0.8rem !important;
      width: 100%;
      padding: 0 !important;
      overflow: visible;
    }

    .rcl__swatch {
      position: relative;
      box-sizing: border-box;
      flex: 0 0 4rem;
      width: 4rem !important;
      height: 4rem !important;
      min-width: 0 !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0.3rem !important;
      border: 0.1rem solid rgba(18, 18, 18, 0.18) !important;
      border-radius: 50% !important;
      background: #fff !important;
      box-shadow: 0 0.25rem 0.9rem rgba(216, 79, 128, 0.1);
      cursor: pointer;
      overflow: visible !important;
      transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
    }

    .rcl__swatch-media {
      width: 100% !important;
      height: 100% !important;
      aspect-ratio: 1;
      border-radius: 50% !important;
      background: #fff;
      overflow: hidden;
    }

    .rcl__swatch-media img,
    .rcl__swatch-media svg {
      display: block;
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
    }

    .rcl__swatch.rcl__swatch--button {
      flex: 0 0 auto !important;
      width: auto !important;
      min-width: 5.4rem !important;
      height: 4rem !important;
      min-height: 4rem !important;
      aspect-ratio: auto !important;
      padding: 0.45rem 1rem !important;
      border-radius: 999px !important;
    }

    .rcl__swatch--button .rcl__button-content {
      width: auto !important;
      height: 100% !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .rcl__swatch--button .rcl__button-label {
      display: block !important;
      color: #4f4650 !important;
      font-size: 1.15rem !important;
      font-weight: 750 !important;
      line-height: 1 !important;
      white-space: nowrap !important;
    }

    .rcl__swatch:hover {
      z-index: 2;
      border-color: var(--dream-rubik-pink) !important;
      box-shadow: 0 0 0 0.35rem var(--dream-rubik-soft), 0 0.5rem 1.2rem rgba(216, 79, 128, 0.18);
      transform: translateY(-0.15rem) scale(1.04);
    }

    .rcl__swatch:focus-visible {
      outline: 0.25rem solid var(--dream-rubik-pink) !important;
      outline-offset: 0.25rem !important;
    }

    .rcl__swatch--active {
      z-index: 1;
      border-color: var(--dream-rubik-pink) !important;
      outline: 0.25rem solid var(--dream-rubik-pink) !important;
      outline-offset: 0.2rem !important;
      box-shadow: 0 0 0 0.45rem rgba(239, 108, 152, 0.14), 0 0.5rem 1.4rem rgba(216, 79, 128, 0.2) !important;
    }

    .rcl__swatch--active::after {
      content: '✓';
      position: absolute;
      top: -0.45rem;
      right: -0.45rem;
      display: grid;
      place-items: center;
      width: 1.75rem;
      height: 1.75rem;
      box-sizing: border-box;
      border: 0.2rem solid #fff;
      border-radius: 50%;
      background: var(--dream-rubik-pink);
      color: #fff;
      font-size: 1rem;
      font-weight: 800;
      line-height: 1;
    }

    @media screen and (max-width: 749px) {
      .rcl__group {
        padding: 1rem 0.9rem 1.1rem;
      }

      .rcl__grid {
        display: grid !important;
        grid-template-columns: repeat(6, minmax(0, 1fr));
        gap: clamp(0.4rem, 1.6vw, 0.8rem) !important;
      }

      .rcl__group.dream-rubik-text-options .rcl__grid {
        display: flex !important;
        flex-wrap: wrap !important;
        justify-content: flex-start !important;
      }

      .rcl__swatch {
        width: 100% !important;
        height: auto !important;
        aspect-ratio: 1;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .rcl__swatch {
        transition: none;
      }
    }
  `;

  const cardStyles = `
    :host {
      --dream-rubik-card-pink: #ef6c98;
      --dream-rubik-card-pink-dark: #d84f80;
      --dream-rubik-card-border: rgba(239, 108, 152, 0.28);
      --dream-rubik-card-soft: rgba(239, 108, 152, 0.07);
      display: block;
      width: 100%;
      min-width: 0;
      margin: 0.2rem 0 0.7rem;
    }

    .rcl__group {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      min-width: 0;
      min-height: 5.4rem;
      margin: 0 !important;
      padding: 0.45rem 0.5rem 0.55rem !important;
      border: 0.1rem solid var(--dream-rubik-card-border);
      border-radius: 1.2rem;
      background: linear-gradient(135deg, #fff 15%, var(--dream-rubik-card-soft));
    }

    .rcl__group-label {
      display: flex !important;
      align-items: center;
      justify-content: center;
      gap: 0.35rem !important;
      width: 100%;
      min-width: 0;
      margin: 0 0 0.35rem !important;
      color: #4f4650 !important;
      font-size: 1.05rem !important;
      font-weight: 650 !important;
      line-height: 1.2 !important;
      white-space: nowrap;
      overflow: hidden;
    }

    .rcl__group-label-option-name,
    .rcl__group-label-separator,
    .rcl__group-label-selected-value {
      display: inline-flex !important;
      align-items: center;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .rcl__group-label-option-name {
      flex: 0 0 auto;
      font-weight: 750 !important;
    }

    .rcl__group-label-separator {
      flex: 0 0 auto;
      color: var(--dream-rubik-card-pink) !important;
    }

    .rcl__group-label-selected-value {
      flex: 0 1 auto;
      color: var(--dream-rubik-card-pink-dark) !important;
      font-weight: 750 !important;
    }

    .rcl__grid {
      display: flex !important;
      flex-wrap: nowrap !important;
      align-items: center;
      justify-content: center !important;
      gap: 0.55rem !important;
      width: 100%;
      min-width: 0;
      margin: 0 !important;
      box-sizing: border-box;
      padding: 0.45rem 0.65rem 0.45rem !important;
      overflow-x: auto !important;
      overflow-y: hidden !important;
      scroll-snap-type: x proximity;
      scrollbar-width: none;
      -webkit-overflow-scrolling: touch;
    }

    .rcl__grid::-webkit-scrollbar {
      display: none;
    }

    .rcl__group.dream-rubik-overflow .rcl__grid {
      justify-content: flex-start !important;
      padding-right: 1.8rem !important;
    }

    .rcl__group.dream-rubik-overflow::after {
      content: '\u203a';
      position: absolute;
      top: 2.55rem;
      right: 0.35rem;
      z-index: 3;
      display: grid;
      place-items: center;
      width: 1.55rem;
      height: 1.55rem;
      border: 0.1rem solid rgba(239, 108, 152, 0.3);
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.94);
      color: var(--dream-rubik-card-pink-dark);
      font-size: 1.45rem;
      font-weight: 800;
      line-height: 1;
      pointer-events: none;
      box-shadow: 0 0.25rem 0.75rem rgba(216, 79, 128, 0.14);
    }

    .rcl__swatch {
      position: relative;
      box-sizing: border-box;
      flex: 0 0 3.5rem !important;
      width: 3.5rem !important;
      height: 3.5rem !important;
      min-width: 3.5rem !important;
      min-height: 3.5rem !important;
      margin: 0 !important;
      padding: 0.22rem !important;
      border: 0.1rem solid rgba(79, 70, 80, 0.22) !important;
      border-radius: 50% !important;
      background: #fff !important;
      box-shadow: 0 0.2rem 0.65rem rgba(216, 79, 128, 0.08);
      scroll-snap-align: center;
      cursor: pointer;
      overflow: visible !important;
      transition: transform 150ms ease, border-color 150ms ease, box-shadow 150ms ease;
    }

    .rcl__swatch-media {
      width: 100% !important;
      height: 100% !important;
      aspect-ratio: 1;
      border-radius: 50% !important;
      background: #fff;
      overflow: hidden;
    }

    .rcl__swatch-media img,
    .rcl__swatch-media svg {
      display: block;
      width: 100% !important;
      height: 100% !important;
      object-fit: contain !important;
    }

    .rcl__swatch.rcl__swatch--button {
      flex: 0 0 auto !important;
      width: auto !important;
      min-width: 4.8rem !important;
      height: 3.5rem !important;
      min-height: 3.5rem !important;
      aspect-ratio: auto !important;
      padding: 0.35rem 0.8rem !important;
      border-radius: 999px !important;
    }

    .rcl__swatch--button .rcl__button-content {
      width: auto !important;
      height: 100% !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .rcl__swatch--button .rcl__button-label {
      display: block !important;
      color: #4f4650 !important;
      font-size: 1rem !important;
      font-weight: 750 !important;
      line-height: 1 !important;
      white-space: nowrap !important;
    }

    .rcl__swatch:hover {
      z-index: 2;
      border-color: var(--dream-rubik-card-pink) !important;
      box-shadow: 0 0 0 0.25rem var(--dream-rubik-card-soft), 0 0.35rem 0.9rem rgba(216, 79, 128, 0.18);
      transform: translateY(-0.1rem);
    }

    .rcl__swatch:focus-visible {
      outline: 0.2rem solid var(--dream-rubik-card-pink) !important;
      outline-offset: 0.2rem !important;
    }

    .rcl__swatch--active {
      z-index: 1;
      border-color: var(--dream-rubik-card-pink) !important;
      outline: 0.2rem solid var(--dream-rubik-card-pink) !important;
      outline-offset: 0.15rem !important;
      box-shadow: 0 0 0 0.35rem rgba(239, 108, 152, 0.13), 0 0.35rem 0.95rem rgba(216, 79, 128, 0.2) !important;
    }

    .rcl__swatch--active::after {
      content: '\u2713';
      position: absolute;
      top: -0.1rem;
      right: -0.1rem;
      display: grid;
      place-items: center;
      box-sizing: border-box;
      width: 1.35rem;
      height: 1.35rem;
      border: 0.15rem solid #fff;
      border-radius: 50%;
      background: var(--dream-rubik-card-pink);
      color: #fff;
      font-size: 0.8rem;
      font-weight: 800;
      line-height: 1;
    }

    @media screen and (min-width: 750px) {
      :host {
        max-width: 100% !important;
        overflow: hidden !important;
        contain: inline-size;
      }

      .rcl__group {
        max-width: 100% !important;
        overflow: hidden !important;
      }

      .rcl__grid {
        max-width: 100% !important;
      }
    }

    @media screen and (max-width: 749px) {
      .rcl__group {
        min-height: 5rem;
        padding-inline: 0.35rem !important;
      }

      .rcl__group-label {
        font-size: 0.95rem !important;
      }

      .rcl__swatch {
        flex-basis: 3rem !important;
        width: 3rem !important;
        height: 3rem !important;
        min-width: 3rem !important;
        min-height: 3rem !important;
      }

      .rcl__swatch.rcl__swatch--button {
        width: auto !important;
        min-width: 4.6rem !important;
        height: 3rem !important;
        min-height: 3rem !important;
        padding-inline: 0.7rem !important;
      }

      .rcl__swatch--button .rcl__button-label {
        font-size: 0.9rem !important;
      }

      .rcl__group.dream-rubik-overflow::after {
        top: 2.35rem;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .rcl__swatch {
        transition: none;
      }
    }
  `;

  const enhanceComponent = (component) => {
    const root = component.shadowRoot;
    if (!root) return false;

    const isCard = Boolean(component.closest('.card-wrapper, .product-card-wrapper, .product_card_slide'));
    const styleId = isCard ? cardStyleId : productStyleId;
    const styles = isCard ? cardStyles : productStyles;

    component.classList.toggle('dream-rubik-card', isCard);

    if (!root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = styles;
      root.appendChild(style);
    }

    const group = root.querySelector('.rcl__group');
    if (group) {
      group.classList.toggle('dream-rubik-text-options', Boolean(group.querySelector('.rcl__swatch--button')));
    }

    if (isCard) {
      const grid = root.querySelector('.rcl__grid');
      if (group && grid) {
        window.requestAnimationFrame(() => {
          group.classList.toggle('dream-rubik-overflow', grid.scrollWidth > grid.clientWidth + 2);
        });
      }
    }

    return true;
  };

  const enhanceAll = () => {
    let pending = false;
    document.querySelectorAll(componentName).forEach((component) => {
      if (!enhanceComponent(component)) pending = true;
    });
    return pending;
  };

  const start = () => {
    enhanceAll();

    const observer = new MutationObserver(enhanceAll);
    observer.observe(document.documentElement, { childList: true, subtree: true });

    let attempts = 0;
    const retry = window.setInterval(() => {
      attempts += 1;
      const pending = enhanceAll();
      if ((!pending && document.querySelector(componentName)) || attempts >= 20) window.clearInterval(retry);
    }, 500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
